/*
 * @Description: 网点管家对接沙滩说 兔学堂和学习任务 列表
 * @Author: gaolei
 * @Date: 2025-08-26
 * @LastEditTime: 2025-08-26
 * @LastEditors: gaolei
 */

import { useAuthStore } from '@/stores/login'
import { loading } from '@/utils/loading'
import dsBridge from 'dsbridge'
import router from '@/router'
import { useUsersStore } from '@/stores/users'
import { getQueryString } from '.'

// 判断是否是网点管家外场App
export const isBranchManagerApp = window.navigator.userAgent.indexOf('cn_network_app') > -1

// 在文件的顶部添加以下代码来扩展 Window 接口
declare global {
  interface Window {
    jtJsBridge?: {
      jtH5CallNativeApi: (request: any, callback: (responseData: any) => void) => void
    }
  }
}

// 调用外场方法（使用 dsBridge）
const callNative = async (request: { method: string; data?: any }): Promise<any> => {
  return new Promise((resolve, reject) => {
    if (isBranchManagerApp) {
      dsBridge.call('jtH5CallNativeApi', request, (responseData) => {
        // console.log('=======response: ' + responseData)
        if (responseData && typeof responseData === 'string') {
          try {
            const parsedResponse = JSON.parse(responseData)
            resolve(parsedResponse)
          } catch (error) {
            resolve(responseData)
          }
        } else {
          resolve(responseData)
        }
      })
    }
  })
}

// 获取网点管家token（使用 UserTokenChannel）
export const branchManagerLogin = async () => {
  loading.show()
  try {
    const sourceType = getQueryString('sourceType') || ''
    const request = { method: 'SandsTalkTokenChannel', data: {} }
    const res = await callNative(request)

    const resData = typeof res === 'string' ? JSON.parse(res) : res
    console.log(resData, '用户Token信息=====')

    if (resData.code === -1) {
      // 错误直接退出到App，并提示错误信息
      branchManagerShowToast(resData.message)
      branchManagerCloseWebview()
      return {}
    }

    const authStore = useAuthStore()
    const usersStore = useUsersStore()
    const { setCollegeId } = usersStore
    const { access_token, tenantId, collegeId, language } = resData.data
    // console.log(access_token, '用户Token信息3--最终data数据')

    if (!access_token) {
      throw new Error('Token不存在')
    }
    authStore.setAccessToken(access_token)
    localStorage.setItem('sandsTalkToken', access_token)
    localStorage.setItem('sandsTalkTenantId', tenantId || '1000')
    localStorage.setItem('lang', language || 'id')
    setCollegeId(collegeId)
    if (sourceType && sourceType === 'training') {
      router.replace('/myTraining')
    } else {
      router.replace('/')
    }
    return access_token
  } catch (error) {
    // console.error('获取Token失败:', error);
    branchManagerCloseWebview()
    return {}
  } finally {
    loading.hide()
  }
}

// 课程视频 - 是否需要全屏显示，按需使用  （仅课程视频使用）
export const branchManagerSetHoriVerti = (isFull: boolean) => {
  const request = { method: 'OrientationChannel', data: { isFull } }
  callNative(request)
}

// 网点管家下载H5链接  (文件下载)
export const branchManagerDownloadH5Url = (url: string, name: string) => {
  const request = { method: 'OpenFileChannel', data: { url, name } }
  callNative(request)
}

// 加载外部url内容
export const branchManagerGoToNativeLoadUrl = (url: string) => {
  const request = { method: 'OpenH5PageChannel', data: { url } }
  callNative(request)
}

// 网点管家关闭webview
export const branchManagerCloseWebview = async () => {
  const request = { method: 'FinishPageChannel' }
  await callNative(request)
}

/**
 * 注册 Native 调用 H5 的方法 ：app 调用H5
 * @param handler
 */
export function registerNative(handler: object | (() => any)) {
  // jtNativeCallH5Api 与原生协商固定
  dsBridge.register('jtNativeCallH5Api', handler)
}

// 网点管家Toast提示
export const branchManagerShowToast = (message: string) => {
  const request = { method: 'ToastChannel', data: { message } }
  callNative(request)
}
